var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f88e91a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "textFieldContainer" };
const _hoisted_2 = { class: "addContactLabel" };
const _hoisted_3 = { class: "error" };
const _hoisted_4 = { class: "textFieldContainer" };
const _hoisted_5 = { class: "addContactLabel" };
const _hoisted_6 = { class: "error" };
const _hoisted_7 = { class: "textFieldContainer" };
const _hoisted_8 = { class: "addContactLabel" };
const _hoisted_9 = { class: "error" };
const _hoisted_10 = { class: "textFieldContainer" };
const _hoisted_11 = { class: "addContactLabel" };
const _hoisted_12 = {
    key: 0,
    class: "mt-5 text-red-40 flex justify-center text-error-700"
};
const _hoisted_13 = { class: "addContactsFooter" };
import Contact from '@/models/contact';
import { ContactService } from '@/service/ContactService';
import AppState from '@/states/book_appointment';
import { timezones } from '@/utils/timezones';
import { UIButton, UIInput, UIModal, UIModalHeader, UISelect, } from '@gohighlevel/ghl-ui';
import libphonenumber from 'google-libphonenumber';
import { computed, onMounted, ref } from 'vue';
import PhoneNumberInput from '../common/PhoneNumberInput.vue';
import { appointmentWizardState } from './appointmentWizardState';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AddContact',
    props: {
        addContact: Boolean,
    },
    setup(__props) {
        const props = __props;
        const name = ref('');
        const mobileNo = ref('');
        const email = ref('');
        const serverError = ref('');
        const selectedTimezone = ref('');
        const errors = ref({ name: '', email: '', mobileNo: '' });
        const showSaveContactLoader = ref(false);
        const isLoading = ref(false);
        onMounted(() => {
            selectedTimezone.value = locationTimezone.value;
        });
        // Function to validate contact details before saving
        const validateContactDetails = () => {
            let isValid = true;
            // Regular expression for validating email format
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            // Check if the name is at least 3 characters long
            if (name.value.length < 3) {
                errors.value.name = 'Name is required';
                isValid = false;
            }
            // Validate the email using the regex pattern
            if (email.value && !emailRegex.test(email.value)) {
                errors.value.email = 'Invalid Email';
                isValid = false;
            }
            // Validate the phone number
            if (mobileNo.value && !validatePhoneNumber()) {
                isValid = false;
            }
            if (!email.value && !mobileNo.value) {
                serverError.value = 'Email or Mobile is required';
                isValid = false;
            }
            return isValid;
        };
        // Function to validate the phone number using libphonenumber library
        const validatePhoneNumber = () => {
            let isValid = true;
            errors.value.mobileNo = '';
            try {
                const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
                const parsedNumber = phoneUtil.parseAndKeepRawInput(mobileNo.value);
                if (!(phoneUtil.isValidNumber(parsedNumber) &&
                    phoneUtil.isPossibleNumber(parsedNumber))) {
                    isValid = false;
                    errors.value.mobileNo = 'Invalid phone number';
                }
            }
            catch (error) {
                isValid = false;
                errors.value.mobileNo = 'Invalid phone number';
            }
            return isValid;
        };
        // Function to handle saving contact details
        const onSaveButtonClick = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            errors.value.mobileNo = '';
            errors.value.name = '';
            errors.value.email = '';
            serverError.value = '';
            if (validateContactDetails()) {
                showSaveContactLoader.value = true;
                isLoading.value = true;
                serverError.value = '';
                const contactDetails = {
                    name: name.value,
                    phone: mobileNo.value,
                    locationId: AppState.locationId,
                    timezone: selectedTimezone.value,
                };
                if (email.value) {
                    contactDetails.email = email.value;
                }
                try {
                    // Send the contact details to the server for creation
                    const { data } = yield ContactService.create(contactDetails);
                    // Depending on the context, update the selected contact or guests list
                    if (props.addContact) {
                        AppState.selectedContact = new Contact(data.contact);
                        appointmentWizardState.contactError = '';
                    }
                    else {
                        appointmentWizardState.guestsRef.push(new Contact(data.contact));
                    }
                    isLoading.value = false;
                    toggleShowContactModal();
                }
                catch (error) {
                    if (error.response) {
                        serverError.value =
                            'This location does not allow duplicated contacts.' ===
                                ((_a = error.response.data) === null || _a === void 0 ? void 0 : _a.message)
                                ? 'The contact associated with this email address/phone number already exists.'
                                : ((_b = error.response.data) === null || _b === void 0 ? void 0 : _b.message) || 'Failed To Save Contact';
                    }
                    isLoading.value = false;
                }
                showSaveContactLoader.value = false;
            }
        });
        // Computed property to get the location's timezone
        const locationTimezone = computed(() => {
            return (AppState === null || AppState === void 0 ? void 0 : AppState.timezone) || 'UTC';
        });
        // Computed property to generate timezone options with default indication
        const computedTimezones = computed(() => {
            return timezones.map(timezone => {
                return {
                    label: `${timezone.label} ${locationTimezone.value == timezone.value ? '(Default)' : ''}`,
                    value: timezone.value,
                };
            });
        });
        // Function to toggle the visibility of the contact modal
        const toggleShowContactModal = () => {
            appointmentWizardState.showAddContactModal =
                !appointmentWizardState.showAddContactModal;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: _unref(appointmentWizardState).showAddContactModal,
                width: _unref(appointmentWizardState).width
            }, {
                header: _withCtx(() => [
                    _createCommentVNode(" Modal header with title and close button "),
                    _createVNode(_unref(UIModalHeader), {
                        id: __props.addContact ? 'add-contact-header' : 'add-guest-header',
                        title: __props.addContact ? _ctx.$t('addContact.add_contact') : 'Add new guest',
                        onClose: toggleShowContactModal
                    }, null, 8 /* PROPS */, ["id", "title"])
                ]),
                footer: _withCtx(() => [
                    _createCommentVNode(" Footer buttons for canceling and saving contact "),
                    _createElementVNode("div", _hoisted_13, [
                        _createVNode(_unref(UIButton), {
                            id: __props.addContact
                                ? 'contact-creation-cancel-contact-button'
                                : 'add-guest-cancel-guest-button',
                            type: "default",
                            onClick: toggleShowContactModal,
                            disabled: showSaveContactLoader.value
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.back')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["id", "disabled"]),
                        _createVNode(_unref(UIButton), {
                            id: __props.addContact
                                ? 'contact-creation-save-contact-button'
                                : 'add-guest-save-guest-button',
                            type: "primary",
                            onClick: onSaveButtonClick,
                            disabled: showSaveContactLoader.value,
                            loading: showSaveContactLoader.value
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["id", "disabled", "loading"])
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: "addContactMainContainer",
                        style: _normalizeStyle({ height: _unref(appointmentWizardState).height })
                    }, [
                        _createCommentVNode(" Text field for entering contact's name "),
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('addContact.name')), 1 /* TEXT */),
                            _createVNode(_unref(UIInput), {
                                id: __props.addContact ? 'contact-creation-name-input' : 'add-guest-name-input',
                                modelValue: name.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event)),
                                placeholder: __props.addContact
                                    ? 'eg (John doe)'
                                    : _ctx.$t('addGuests.guest_name_placeholder')
                            }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"]),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(errors.value.name), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" Text field for entering contact's phone number "),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('addContact.phone')), 1 /* TEXT */),
                            _createVNode(PhoneNumberInput, {
                                id: __props.addContact
                                    ? 'contact-creation-phone-input'
                                    : 'add-guest-phone-input',
                                modelValue: mobileNo.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((mobileNo).value = $event)),
                                class: "w-full rounded border-gray-300 shadow-sm focus:border-curious-blue-500 focus:ring-curious-blue-500 sm:text-sm",
                                name: "phoneNo",
                                placeholder: __props.addContact
                                    ? '(eg) +1 900 900 9000'
                                    : _ctx.$t('addGuests.guest_phone_placeholder')
                            }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"]),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(errors.value.mobileNo), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" Text field for entering contact's email address "),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('addContact.email')), 1 /* TEXT */),
                            _createVNode(_unref(UIInput), {
                                id: __props.addContact
                                    ? 'contact-creation-email-input'
                                    : 'add-guest-email-input',
                                modelValue: email.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((email).value = $event)),
                                placeholder: __props.addContact
                                    ? '(eg) test@gmail.com'
                                    : _ctx.$t('addGuests.guest_email_placeholder')
                            }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"]),
                            _createElementVNode("div", _hoisted_9, _toDisplayString(errors.value.email), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" Dropdown for selecting contact's timezone "),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('addContact.timezone')), 1 /* TEXT */),
                            _createVNode(_unref(UISelect), {
                                id: __props.addContact
                                    ? 'contact-creation-timezone-dropdown'
                                    : 'add-guest-timezone-dropdown',
                                value: selectedTimezone.value,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event) => ((selectedTimezone).value = $event)),
                                options: computedTimezones.value,
                                filterable: true,
                                placeholder: _ctx.$t('common.select_one')
                            }, null, 8 /* PROPS */, ["id", "value", "options", "placeholder"])
                        ]),
                        _createCommentVNode(" Display server error message if available "),
                        (serverError.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(__props.addContact ? _ctx.$t('addContact.contact_error') : 'Error saving guest') + " : " + _toDisplayString(serverError.value), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ], 4 /* STYLE */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show", "width"]));
        };
    }
});
